import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Box, Button, Container, Drawer, IconButton, List, ListItem, ListItemButton, ListItemText, Toolbar } from '@mui/material';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const Header = ({ onHandleExplore, onOpenHelpSupport, handleShowSubcription, onOpenPackagesModal, isHideOptions, isfromTSPage }) => {
    const navigate = useNavigate();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const menuItems = [
        { label: 'Topic Pulse', href: '#topic-pulse' },
        { label: 'College Predictor', href: '#college-predictor' },
        { label: 'Test Series', href: '#test-series' },
    ];
    const handleRedirectToLearner = () => {
        navigate("/medineer/SignIn");
    };
    const isOnTestSeriesPage = window.location.pathname === "/medineer/test-series-list" || window.location.pathname === "/medineer/test-series-details";
    const isScrolled = useScrollTrigger({
        disableHysteresis: true,
        threshold: 10,
    });

    return (
        <AppBar
            position="fixed"
            color="default"
            elevation={1}
            sx={{
                backgroundColor: isScrolled
                    ? 'rgba(255, 255, 255, 0.75)'
                    : 'background.paper',

                backdropFilter: isScrolled ? 'blur(12px)' : 'none',
                WebkitBackdropFilter: isScrolled ? 'blur(12px)' : 'none',

                boxShadow: '0 8px 32px rgba(0,0,0,0.08)',

                transition: 'all 0.25s ease',
            }}
        >
            <Container maxWidth="100%">
                <Toolbar sx={{
                    justifyContent: 'space-between', py: 1, pl: '0px !important',
                    pr: '0px !important'
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box
                            sx={{
                                width: 50,
                                height: 50,
                                borderRadius: 2,
                                // background: 'linear-gradient(135deg, hsl(38 100% 50%), hsl(14 100% 60%))',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            {/* <Box component="span" sx={{ fontSize: '2.25rem', fontWeight: 700, color: '#00264D', fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"' }}>
                                M
                            </Box> */}
                            <Box
                                component="img"
                                src="/logo.PNG"     // public folder image
                                alt="Medineer Logo"
                                sx={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain', // or 'cover' if you want full fill
                                }}
                            />
                        </Box>
                        <Box component="span" onClick={() => navigate("/medineer")} sx={{ cursor: 'pointer', fontSize: '2.5rem', fontWeight: 700, color: '#00264D', fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"' }}>
                            MEDINEER
                        </Box>
                    </Box>

                    {isHideOptions === true ? null : (
                        <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 3 }}>
                            {menuItems?.filter(item =>
                                !(
                                    isOnTestSeriesPage &&
                                    (item.href === "#topic-pulse" ||
                                        item.href === "#college-predictor")
                                )
                            )?.map((item) => (
                                <Button
                                    key={item.href}
                                    href={
                                        item.href === '#topic-pulse' ? '#topicPulse' :
                                            item.href === '#college-predictor' ? '#predictor' :
                                                undefined
                                    }
                                    disabled={(item.href === '#topic-pulse' || item.href === '#college-predictor') && isOnTestSeriesPage}
                                    onClick={() => item.href === '#test-series' && onHandleExplore()}
                                    sx={{
                                        fontWeight: 600,
                                        color: '#00264D',
                                        fontSize: '1.6rem',
                                        lineHeight: '2.4rem',
                                        textTransform: 'capitalize'
                                    }}
                                >
                                    {item.label}
                                </Button>
                            ))}
                            {/* <Button
                                onClick={onOpenHelpSupport}
                                sx={{
                                    fontWeight: 600,
                                    color: "#00264D",
                                    fontSize: "1.6rem",
                                    lineHeight: "2.4rem",
                                    textTransform: "capitalize",
                                }}
                            >
                                Help & Support
                            </Button> */}
                        </Box>)}

                    {isHideOptions === true ? null : (<Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2 }}>
                        {/* <Button variant="text"
                            sx={{
                                fontWeight: 600,
                                color: '#00264D',
                                fontSize: '1.4rem',
                                lineHeight: '2.4rem',
                                textTransform: 'capitalize'
                            }}
                            onClick={() => handleRedirectToLearner()}
                        >
                            Sign In
                        </Button> */}
                        {/* {!isOnTestSeriesPage && <Button
                            onClick={onOpenPackagesModal}
                            sx={{
                                fontWeight: 700,
                                fontSize: '1.6rem',
                                lineHeight: '2.4rem',
                                textTransform: 'capitalize',
                                backgroundColor: 'transparent',

                                '&:hover': {
                                    backgroundColor: 'transparent',
                                },
                            }}
                        >

                            <Box
                                component="span"
                                sx={{
                                    background: 'linear-gradient(90deg, #ffa100, #3498DB, #E74C3C)',
                                    backgroundSize: '200% 100%',
                                    fontStyle: 'italic',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    animation: 'shimmerText 2s linear infinite',
                                    filter: 'drop-shadow(0 0 6px rgba(255,161,0,0.45))',

                                    '@keyframes shimmerText': {
                                        '0%': { backgroundPosition: '0% 50%' },
                                        '100%': { backgroundPosition: '200% 50%' },
                                    },

                                    '&:hover': {
                                        animationPlayState: 'paused',
                                    },
                                }}
                            >
                                Special Offers
                            </Box>

                            <Box
                                component="span"
                                sx={{
                                    ml: 0.5,
                                    fontSize: '1.6rem',
                                }}
                            >
                                🎉
                            </Box>
                        </Button>} */}


                        <Button variant="contained" color="secondary" sx={{
                            fontSize: '1.4rem', lineHeight: '2rem', textTransform: 'capitalize', borderRadius: '1rem',
                            fontWeight: 600,
                            '&.MuiButton-root': {
                                paddingY: '1rem',
                                paddingX: '2rem',
                            },
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                        }
                        }
                            onClick={() => handleRedirectToLearner()}
                        >
                            Sign In
                            {/* Get Started */}
                        </Button>
                    </Box>)}
                    {isfromTSPage === true ? (<Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2 }}>
                        {/* <Button variant="text"
                            sx={{
                                fontWeight: 600,
                                color: '#00264D',
                                fontSize: '1.4rem',
                                lineHeight: '2.4rem',
                                textTransform: 'capitalize'
                            }}
                            onClick={() => handleRedirectToLearner()}
                        >
                            Sign In
                        </Button> */}
                        {/* {!isOnTestSeriesPage && <Button
                            onClick={onOpenPackagesModal}
                            sx={{
                                fontWeight: 700,
                                fontSize: '1.6rem',
                                lineHeight: '2.4rem',
                                textTransform: 'capitalize',
                                backgroundColor: 'transparent',

                                '&:hover': {
                                    backgroundColor: 'transparent',
                                },
                            }}
                        >

                            <Box
                                component="span"
                                sx={{
                                    background: 'linear-gradient(90deg, #ffa100, #3498DB, #E74C3C)',
                                    backgroundSize: '200% 100%',
                                    fontStyle: 'italic',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    animation: 'shimmerText 2s linear infinite',
                                    filter: 'drop-shadow(0 0 6px rgba(255,161,0,0.45))',

                                    '@keyframes shimmerText': {
                                        '0%': { backgroundPosition: '0% 50%' },
                                        '100%': { backgroundPosition: '200% 50%' },
                                    },

                                    '&:hover': {
                                        animationPlayState: 'paused',
                                    },
                                }}
                            >
                                Special Offers
                            </Box>

                            <Box
                                component="span"
                                sx={{
                                    ml: 0.5,
                                    fontSize: '1.6rem',
                                }}
                            >
                                🎉
                            </Box>
                        </Button>} */}


                        <Button variant="contained" color="secondary" sx={{
                            fontSize: '1.4rem', lineHeight: '2rem', textTransform: 'capitalize', borderRadius: '1rem',
                            fontWeight: 600,
                            '&.MuiButton-root': {
                                paddingY: '1rem',
                                paddingX: '2rem',
                            },
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                        }
                        }
                            onClick={() => handleRedirectToLearner()}
                        >
                            Sign In
                            {/* Get Started */}
                        </Button>
                    </Box>) : null}

                    {isfromTSPage === true ? (<IconButton sx={{ display: { xs: 'flex', md: 'none' } }} onClick={() => setMobileMenuOpen(true)}>
                        <MenuIcon />
                    </IconButton>) : null}
                    {isHideOptions === true ? null : (<IconButton sx={{ display: { xs: 'flex', md: 'none' } }} onClick={() => setMobileMenuOpen(true)}>
                        <MenuIcon />
                    </IconButton>)}

                    <Drawer anchor="top" open={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)}>
                        <Box sx={{ width: 250, pt: 2 }}>
                            {isHideOptions === true ? null : (<List>
                                {menuItems.filter(item =>
                                    !(
                                        isOnTestSeriesPage &&
                                        (item.href === "#topic-pulse" ||
                                            item.href === "#college-predictor")
                                    )
                                ).map((item) => (
                                    <ListItem key={item.href} disablePadding>
                                        <ListItemButton
                                            disabled={(item.href === '#topic-pulse' || item.href === '#college-predictor') && isOnTestSeriesPage}
                                            href={
                                                item.href === '#topic-pulse' ? '#topicPulse' :
                                                    item.href === '#college-predictor' ? '#predictor' :
                                                        undefined
                                            }
                                            onClick={() => item.href === '#test-series' && onHandleExplore()}
                                        >
                                            <ListItemText primary={item.label} />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                                {/* <ListItem disablePadding>
                                    <ListItemButton
                                        onClick={() => {
                                            setMobileMenuOpen(false);
                                            onOpenHelpSupport();
                                        }}
                                    >
                                        <ListItemText primary="Help & Support" />
                                    </ListItemButton>
                                </ListItem> */}
                            </List>)}

                            <Box sx={{ px: 2, pt: 1, pb: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
                                {/* {!isOnTestSeriesPage && <ListItem disablePadding>
                                    <ListItemButton onClick={onOpenPackagesModal}>
                                        <ListItemText
                                            primary={
                                                <>
                                                    <Box
                                                        component="span"
                                                        sx={{
                                                            fontWeight: 700,
                                                            fontSize: '1.05rem',
                                                            fontStyle: 'italic',
                                                            background: 'linear-gradient(90deg, #ffa100, #3498DB, #E74C3C)',
                                                            backgroundSize: '200% 100%',
                                                            WebkitBackgroundClip: 'text',
                                                            WebkitTextFillColor: 'transparent',
                                                            animation: 'shimmerText 2s linear infinite',
                                                            filter: 'drop-shadow(0 0 6px rgba(255,161,0,0.5))',

                                                            '@keyframes shimmerText': {
                                                                '0%': { backgroundPosition: '0% 50%' },
                                                                '100%': { backgroundPosition: '200% 50%' },
                                                            },

                                                            '&:hover': {
                                                                animationPlayState: 'paused',
                                                            },
                                                        }}
                                                    >
                                                        Special Offers
                                                    </Box>

                                                    <Box
                                                        component="span"
                                                        sx={{
                                                            ml: 0.5,
                                                            fontSize: '1.05rem',
                                                        }}
                                                    >
                                                        🎉
                                                    </Box>
                                                </>
                                            }
                                        />
                                    </ListItemButton>
                                </ListItem>} */}

                                <Button
                                    variant="outlined"
                                    fullWidth
                                    onClick={() => handleRedirectToLearner()}
                                >Sign In</Button>
                                {/* <Button variant="contained" color="secondary" fullWidth>Get Started</Button> */}
                            </Box>
                        </Box>
                    </Drawer>
                </Toolbar>
            </Container>
        </AppBar >
    );
};